module.exports = __webpack_public_path__ + "img/3-4.ea1d6e73.svg";